export const isServicesEnabled = window.env.feature.isServicesEnabled
